import { action, makeObservable, observable, reaction } from 'mobx';
import api from '../utils/api';

import { convertToPercentage } from '@src/utils/pricing';

class TeachersRepository {
  isVideoModalOpen = false;
  videoUrl = null;
  sortOrder = 'asc';
  currentPage = 1;
  allTeacherGeneralInfo = [];

  allTeacherDetailsInfo = [];

  constructor() {
    makeObservable(this, {
      isVideoModalOpen: observable,
      toggleVideoModal: action,
    });
    makeObservable(this, {
      allTeacherDetailsInfo: observable,
    });
    makeObservable(this, {
      allTeacherGeneralInfo: observable,
    });
  }

  async getTeacherDetailsInfoById(id) {
    const lookup = this.allTeacherDetailsInfo.find((teacher) => {
      if (teacher.id === id) {
        return teacher;
      }

      return false;
    });

    if (lookup) {
      return lookup;
    }

    const data = await this.loadTeacherInfo({ id });

    this.allTeacherDetailsInfo.push(data);

    return data;
  }

  async loadTeacherInfo({ id }) {
    const teacherDto = await api.get(`teachers/single/${id}`);

    const teacherPm = {
      id: `${teacherDto.userId}`,
      slug: teacherDto.tag,
      name: teacherDto.firstName,
      description: teacherDto.description,
      subjects: teacherDto.teacherSubjects,
      avatarUrl: teacherDto.avatarUrl,
      videoUrl: teacherDto.videoUrl,
      price: teacherDto.lessonPrice,
      groupLessonMax: teacherDto.groupLessonMax,
      currency: teacherDto.currency,
      teachingLanguages: teacherDto.teachingLanguages,
      isFeatured: teacherDto.isFeatured,
      rating: {
        width: convertToPercentage(teacherDto.rating, 5),
        value: teacherDto.rating,
        count: teacherDto.ratingCount,
      },
      feedback:
        teacherDto.ratings &&
        teacherDto.ratings.map((ratingDto) => {
          return {
            id: ratingDto.id,
            author: ratingDto.byUserDisplayName,
            avatar: '', // missing in API
            text: ratingDto.comment,
            rating: convertToPercentage(ratingDto.rating, 5),
          };
        }),
      stats: {
        dayCount: teacherDto.dayCount,
        lessonCount: teacherDto.lessonCount,
        messageCount: teacherDto.messageCount,
      },
      calendar: teacherDto.calendor,
    };

    return teacherPm;
  }

  loadModalState = (callback) => {
    reaction(
      () => this.isVideoModalOpen,
      () =>
        callback({
          isOpen: this.isVideoModalOpen,
          videoUrl: this.videoUrl,
        }),
      { fireImmediately: true }
    );
  };

  toggleVideoModal = (videoUrl) => {
    if (!this.isVideoModalOpen) {
      // todo fix in backend data
      this.videoUrl = videoUrl && videoUrl.replace('/videos/', '/video/');
    } else {
      this.videoUrl = null;
    }
    this.isVideoModalOpen = !this.isVideoModalOpen;
  };
}

const teachersRepository = new TeachersRepository();

export default teachersRepository;
